import React, { useEffect } from 'react';
import styled from 'styled-components';
// Will remove after intro-widgets-api change is in the VS
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getFeedbackTriggerProps } from '@amzn/intro-widgets-api';
import { PeekabooStickyTab } from '@amzn/storm-ui-v3-feedback-form-kit';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { useFooterBundle } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';
import { logWithTakt } from 'src/commons/utils/logWithTakt';
import { FeedbackTriggerPublisher } from 'src/commons/utils/metrics';

const StyledPeekabooStickyTab = styled(PeekabooStickyTab)`
  &&& {
    bottom: 6rem;
    z-index: 2;
  }
`;
const componentId = 'AD_CONSOLE_PAGE_LEVEL_FEEDBACK';
const cssfElementId = 'FITCSSF';

const FeedbackTrigger: React.VFC = () => {
  const chromeConfig = useChromeConfigContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const bundle = useFooterBundle();
  const cssfElement = document.getElementById(cssfElementId);
  const app = internalChromeConfig?.applicationName;
  const page = chromeConfig?.pageId || 'Unknown';

  useEffect(() => {
    if (cssfElement) {
      logWithTakt(
        `cssf-feedback-trigger-loaded-${app}-${page}-${componentId}`,
        {},
      );
      FeedbackTriggerPublisher.publishCounterMonitor(
        `rendered-${app}-${page}-${componentId}`,
        1,
      );
    }
  }, []);

  if (!cssfElement) {
    return null;
  }

  return (
    <StyledPeekabooStickyTab
      side="end"
      {...getFeedbackTriggerProps({
        application: app ?? '',
        page: page,
        component: componentId,
      })}
    >
      {bundle.getMessage('footer-feedback')}
    </StyledPeekabooStickyTab>
  );
};

export default FeedbackTrigger;
